<template>
	<div tabindex="0" class="hide-outline" :class="this.isMobile ? 'is-mobile' : ''">
		<main class="main-view no-top-panel">
			<div>
				<div class="title">
					{{ localMove.id != 0 ? $t('movewizard.edit_move_title') : $t('movewizard.new_move_title') }} {{$t('movewizard.move_title_suffix')}}

					{{
						(localMove.fromCustomerName ? ' - ' + localMove.fromCustomerName + ' | ' + localMove.targetCustomerName : "")
					}}
				</div>
				<div class="top-box">
					<div class="row" :style="mobile">
						<div class="fields">
							<div class="field">
								<label class="label">{{$t('movewizard.from_customer_label')}}</label>
								<button class="customer-select-button" :disabled="localMove.id ? true : false" @click="openCustomerSelect(true)">{{ selectedFromCustomer.name }}</button>
							</div>
							<div class="field">
								<label class="label">{{$t('movewizard.to_customer_label')}}</label>
								<button class="customer-select-button" :disabled="localMove.id ? true : false" @click="openCustomerSelect(false)">{{ selectedToCustomer.name }}</button>
							</div>
						</div>
						
						<div class="field buttons" v-if="!isMobile">
							<button class="button is-dark" @click="cancel">
								<span class="icon"><i class="fas fa-backward"/></span>
								<span>{{$t('movewizard.back_button')}}</span>
							</button>
							<button
								class="button is-info"
								:class="loading ? 'is-loading' : ''"
								@click="save"
								:disabled="disableSave"
							>
								<span class="icon is-white"><i class="fas fa-save"/></span>
								<span>{{$t('movewizard.save_button')}}</span>
							</button>
							<button 
								class="button is-dark"
								@click="navigateToSummary"
								:disabled="!localMove.id"
							>
								<span class="icon"><i class="fas fa-file-alt"/></span>
								<span>{{$t('movewizard.summary_button')}}</span>
							</button>
						</div>
					</div>
				</div>

				<TabComponent :tabs="comTabs" fullwidth v-model="selectedTab" />
			</div>
			<div class="lists columns" v-if="showLists && !comUseMappingList"> 
				<LayeredSelectionList v-if="comUseLayeredList"
					:listItems="comAddList"
					:title="comTitle"
					:tab="selectedTab"
					:mode="'add'"
					:subListName="comSubListName"
					:idName="comIdFieldName"
					:subIdName="comSubIdFieldName"
					:displayName="comDisplayName"
					:subDisplayName="comSubDisplayName"
					:showAddGroup="comShowAddGroup"
					:searchValueProp="addSearchValue"
					@selectItem="addSubItem"
					@selectGroup="addAllSubItems"
					@search="searchAdd"
				/>
				<SelectionList v-else
					:listItems="comAddList"
					:title="comTitle"
					:tab="selectedTab"
					:mode="'add'"
					:idName="comIdFieldName"
					:searchValueProp="addSearchValue"
					@selectItem="addItem"
					@search="searchAdd"
				/>
				<LayeredSelectionList v-if="comUseLayeredSelectedList"
					:listItems="comAddedList"
					:title="comTitle"
					:tab="selectedTab"
					:mode="'remove'"
					:selectionOptions="comAddedListItemOptions"
					:subListName="comSubListName"
					:idName="comIdFieldName"
					:subIdName="comSubIdFieldName"
					:displayName="comDisplayName"
					:subDisplayName="comSubDisplayName"
					:showAddGroup="comShowAddGroup"
					:searchValueProp="addedSearchValue"
					@selectItem="removeSubItem"
					@selectGroup="removeAllSubItems"
					@search="searchAdded"
					@selectedItemOptionForGroup="listGroupItemOptionSelect"
				/>
				<SelectionList v-else
					:listItems="comAddedList"
					:title="comTitle"
					:tab="selectedTab"
					:mode="'remove'"
					:selectionOptions="comAddedListItemOptions"
					:blankSelection="blankSelectionAddedList"
					:idName="comIdFieldName"
					:displayName="comSubDisplayName"
					:searchValueProp="addedSearchValue"
					@selectItem="removeItem"
					@search="searchAdded"
					@selectedItemOption="listItemOptionSelect"
				/>
			</div>
			

			<MappingSelectionList v-if="comUseMappingList"
				:fromItems="comAddList"
				:toItems="comTargetList"
				:title="comTitle"
				:tab="selectedTab"
				:mode="'add'"
				:targetCustomerName="localMove.targetCustomerName"
				:targetTypeTitle="selectedTab == 2 ? $t('movewizard.tab_fire_protection') : $t('movewizard.tab_checklists')"
				:fromIdName="comIdFieldName"
				:toIdName="comSubIdFieldName"
				:fromDisplayName="comDisplayName"
				:toDisplayName="comSubDisplayName"
				:selectionOptions="comAddedListItemOptions"
				@selectItem="addItem"
				@search="searchAdd"
				@selectedItemOption="listItemOptionSelect"
				@selectedReplacementOption="listItemReplacementSelect"
			/>
			
			<div class="warnings">
				<div class="warning" :key="'warning' + index" v-for="(warning, index) in comWarningField">{{ warning }}</div>
			</div>
			
			<CustomerSelectionDialog :title="customerSelectionTitle" :disabledCustomerId="disabledCustomerId" v-if="showCustomerSelection" @close="closeCustomerSelect"  @selectCustomer="selectCustomer" />
			
		</main>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SelectionList from '@/components/SelectionList/SelectionList';
import TabComponent from '@/components/TabComponent';
import moveWizard from '@/services/moveWizard';
import floorService from '@/services/floor';
import LayeredSelectionList from './components/LayeredSelectionList';
import MappingSelectionList from './components/MappingSelectionList';
import CustomerSelectionDialog from './components/CustomerSelectionDialog';
export default {
	components: {
		SelectionList,
		TabComponent,
		LayeredSelectionList,
		MappingSelectionList,
		CustomerSelectionDialog
	},
	data() {
		return {
			selectedFromCustomer: {},
			selectedToCustomer: {},
			selectedTab: 0,
			localMove: {
				id: '',
				fromCustomerId: '',
				targetCustomerId: '',
				fromCustomerName: '',
				targetCustomerName: '',
				moveBuildings: [],
				moveRoundPlannings: [],
				moveFireProtections: [],
				moveQuestionLists: [],
				moveRoles: [],
				moveQuestions: [],
				moveUsers: []
			},
			showLists: false,
			addSearchValue: '',
			addedSearchValue: '',
			buildings: [],
			roundPlannings: [],
			targetFireProtections: [],
			targetQuestionLists: [],
			roles: [],
			users: [],
			questions: [],
			rawFireProtections: [],
			rawQuestionLists: [],
			rawRoles: [],
			rawQuestions: [],
			rawUsers: [],
			showCustomerSelection: false,
			customerSelectionTitle: '',
			disabledCustomerId: '',
			selectingFromCustomer: false,
			potentialProblemRoundPlannings: []
		};
	},

	computed: {
		...mapGetters('appStore', ['isMobile', 'loading']),
		...mapGetters('customerStore', ['customers']),
		...mapGetters('user', ['getActiveCustomer', 'getActiveCompany']),
		mobile() {
			return this.isMobile ? { display: 'block' } : '';
		},
		disableSave() {
			return !this.selectedToCustomer.id || this.localMove.moveBuildings?.length == 0 || this.loading > 0  ? true : false;
		},
		blankSelectionAddedList() {
			return this.selectedTab == 0 || this.selectedTab == 1 || this.selectedTab == 2 || this.selectedTab == 3 || this.selectedTab == 4
				? this.$t('movewizard.blank_none_selected', { type: this.comTitle })
				: this.$t('movewizard.blank_all_selected', { type: this.comTitle });
		},
		comWarningField() {
			let warningText = [];
			let foundIndex = -1;
			switch (this.selectedTab) {
			case 0:
				return '';
			case 1:
				this.comAddedList.forEach(roundPlanning => {
					foundIndex = this.potentialProblemRoundPlannings.findIndex(potentialproblem => potentialproblem.roundPlanningId === roundPlanning.oldRoundPlanningId);
					
					if (foundIndex >= 0) {
						this.potentialProblemRoundPlannings.splice(foundIndex, 1);
					}
				});
				
				this.potentialProblemRoundPlannings.forEach(potentialProblem => {
					warningText.push(this.$t('movewizard.warning_missing_building', {
						roundPlanningName: potentialProblem.roundPlanningName,
						buildingName: potentialProblem.buildingName
						})
					);
				});
				
				return warningText;
			case 2:
				return '';
			case 3:
				return '';
			case 4:
				this.roles.forEach(rawRole  => {
					let foundRole = this.localMove.moveRoles.find(role => role.oldRoleId === rawRole.responsibleId);
					
					if (!foundRole) {
						let responsibleRoles = this.roles.map(roundPlanning => {
							let foundRole = roundPlanning.roles.find(role => role.oldRoleId === rawRole.responsibleId);
							
							return foundRole;
						});
						
						responsibleRoles = responsibleRoles.filter((element) => {
							return element !== undefined;
						});
						
						warningText.push(this.$t('movewizard.warning_missing_role', {
							roundPlanningName: rawRole.roundPlanningName,
							roleName: responsibleRoles[0]?.roleName
						}));
					}
				});
				
				return warningText;
			case 5:
				return '';
			case 6:
				return '';
			}
			
			return '';
		},
		comIdFieldName() {
			switch (this.selectedTab) {
			case 0:
			case 1:
				return 'oldBuildingId';
			case 2:
				return 'oldFireProtectionId';
			case 3:
				return 'oldQuestionListId';
			case 4:
				return 'oldRoundPlanningId';
			case 5:
				return 'oldQuestionGroupId';
			case 6:
				return 'oldId';
			}

			return '';
		},
		comSubIdFieldName() {
			switch (this.selectedTab) {
			case 0:
				return 'oldBuildingId';
			case 1:
				return 'oldRoundPlanningId';
			case 2:
				return 'id';
			case 3:
				return 'id';
			case 4:
				return 'oldRoleId';
			case 5:
				return 'oldQuestionId';
			case 6:
				return 'oldId';
			}

			return '';
		},
		comDisplayName() {
			switch (this.selectedTab) {
			case 0:
			case 1:
				return 'buildingName';
			case 2:
				return 'fireProtectionName';
			case 3:
				return 'questionListName';
			case 4:
				return 'roundPlanningName';
			case 5:
				return 'oldQuestionGroupName';
			case 6:
				return 'name';
			}

			return '';
		},
		comSubDisplayName() {
			switch (this.selectedTab) {
			case 0:
				return 'buildingName';
			case 1:
				return 'roundPlanningName';
			case 2:
				return 'name';
			case 3:
				return 'name';
			case 4:
				return 'roleName';
			case 5:
				return 'questionName';
			case 6:
				return 'name';
			}

			return '';
		},
		comTitle() {
			switch (this.selectedTab) {
			case 0:
				return this.$t('movewizard.tab_buildings');
			case 1:
				return this.$t('movewizard.tab_round_plans');
			case 2:
				return this.$t('movewizard.tab_fire_protection');
			case 3:
				return this.$t('movewizard.tab_checklists');
			case 4:
				return this.$t('movewizard.tab_roles');
			case 5:
				return this.$t('movewizard.tab_questions');
			case 6:
				return this.$t('movewizard.tab_users');
			}

			return '';
		},
		comShowAddGroup() {
			switch (this.selectedTab) {
			case 0:
			case 1:
			case 2:
			case 3:
			case 4:
			case 6:
				return false;
			case 5:
				return true;
			}

			return false;
		},
		comAddList() {
			let list = [];
			let searchName = 'name';
			let searchSubElement = '';
			
			switch (this.selectedTab) {
			case 0:
				list = this.filterLists(this.buildings, this.localMove.moveBuildings, 'oldBuildingId') || [];
				break;
			case 1:
				list = this.filterLists(this.roundPlannings, this.localMove.moveRoundPlannings, 'oldRoundPlanningId', 'roundPlannings') || [];
				searchSubElement = 'roundPlannings';
				searchName = 'roundPlanningName';
				break;
			case 2:
				list = this.localMove.moveFireProtections || [];
				searchName = 'fireProtectionName';
				break;
			case 3:
				list = this.localMove.moveQuestionLists || [];
				searchName = 'questionListName';
				break;
			case 4:
				list = this.filterLists(this.roles, this.localMove.moveRoles, 'oldRoleId', 'roles') || [];
				searchSubElement = 'roles';
				searchName = 'roleName';
				break;
			case 5:
				list = this.filterLists(this.questions, this.localMove.moveQuestions, 'oldQuestionId', 'questions', true, 'oldQuestionGroupId') || [];
				searchName = 'oldQuestionGroupName';
				break;
			case 6:
				list = this.filterLists(this.rawUsers, this.localMove.moveUsers, 'oldId') || [];
				break;
			}
			
			return this.searchList(list, this.addSearchValue, searchName, searchSubElement);
		},
		comAddedList() {
			let list = [];
			let searchName = 'name';
			
			switch (this.selectedTab) {
			case 0:
				list = this.localMove.moveBuildings || [];
				searchName = 'buildingName';
				break;
			case 1:
				list = this.getUniqueElements(this.localMove.moveRoundPlannings, 'oldRoundPlanningId') || [];
				searchName = 'roundPlanningName';
				break;
			case 2:
				list = this.localMove.moveFireProtections || [];
				break;
			case 3:
				list = this.localMove.moveQuestionLists || [];
				break;
			case 4:
				list = this.localMove.moveRoles || [];
				searchName = 'roleName';
				break;
			case 5:
				list = this.localMove.moveQuestions || [];
				searchName = 'oldQuestionGroupName';
				break;
			case 6:
				list = this.localMove.moveUsers || [];
				break;
			}

			list = this.searchList(list, this.addedSearchValue, searchName, null);
			
			list.sort((a, b) => {
				let nameA;
				let nameB;
				
				if (a.buildingName && b.buildingName) {
					nameA = a.buildingName.toLowerCase();
					nameB = b.buildingName.toLowerCase();
				} else if (a.roundPlanningName && b.roundPlanningName) {
					nameA = a.roundPlanningName.toLowerCase();
					nameB = b.roundPlanningName.toLowerCase();
				} else if (a.questionName && b.questionName) {
					nameA = a.questionName.toLowerCase();
					nameB = b.questionName.toLowerCase();
				} else if (a.oldQuestionGroupName && b.oldQuestionGroupName) {
					nameA = a.oldQuestionGroupName.toLowerCase();
					nameB = b.oldQuestionGroupName.toLowerCase();
				} else if (a.roleName && b.roleName) {
					nameA = a.roleName.toLowerCase();
					nameB = b.roleName.toLowerCase();
				} else {
					nameA = a.name.toLowerCase();
					nameB = b.name.toLowerCase();
				}
				

				if (nameA < nameB) {
					return -1;
				}

				if (nameA > nameB) {
					return 1;
				}

				return 0;
			});

			return list;
		},
		comAddedListItemOptions() {
			let list = [];
			
			switch (this.selectedTab) {
			case 0:
			case 1:
			case 4:
				list = [{name: this.$t('movewizard.option_copy'), value: 0}, {name: this.$t('movewizard.option_move'), value: 1}]

				break;
			case 2:
				list = [
						{ name: this.$t('movewizard.option_copy'), value: 0 },
						{ name: this.$t('movewizard.option_move'), value: 1 }
				];
				if (this.comTargetList.length) {
					list.push({ name: this.$t('movewizard.option_replace'), value: 2 });
				}
				
				break;
			case 3:
				list = [
						{ name: this.$t('movewizard.option_copy'), value: 0 },
						{ name: this.$t('movewizard.option_move'), value: 1 },
						{ name: this.$t('movewizard.option_ignore'), value: 3 }
				];
				if (this.comTargetList.length) {
					list.push({ name: this.$t('movewizard.option_replace'), value: 2 });
				}
									
				break;
			case 5:
				list = [
					{ name: this.$t('movewizard.option_copy'), value: 0 },
					{ name: this.$t('movewizard.option_move'), value: 1 }
				];
				break;
			case 6:
				list = [
					{ name: this.$t('movewizard.option_move'), value: 1 },
					{ name: this.$t('movewizard.option_crosslink'), value: 4 }
				];
				break;
			}
			
			return list;
		},
		comUseMappingList() {
			return this.selectedTab == 2 || this.selectedTab == 3;
		},
		comTargetList() {
			switch (this.selectedTab) {
			case 2:
				return this.targetFireProtections;
			case 3:
				return this.targetQuestionLists;
			}
			
			return [];
		},
		comTabs() {
			return [
				{
					name: this.$t('movewizard.tab_buildings'),
					icon: 'fa-building',
					tag: this.localMove.moveBuildings?.length
				},
				{
					name: this.$t('movewizard.tab_round_plans'),
					icon: 'fa-map',
					tag: this.getUniqueElements(this.localMove.moveRoundPlannings, 'oldRoundPlanningId')?.length,
					disabled: !this.localMove.id || !this.localMove.moveBuildings
				},
				{
					name: this.$t('movewizard.tab_fire_protection'),
					icon: 'fa-fire-extinguisher',
					tag: this.localMove.moveFireProtections?.length,
					disabled: !this.localMove.id || !this.localMove.moveBuildings || !this.localMove.moveRoundPlannings?.length
				},
				{
					name: this.$t('movewizard.tab_checklists'),
					icon: 'fa-tasks',
					tag: this.localMove.moveQuestionLists?.length,
					disabled: !this.localMove.id || !this.localMove.moveBuildings || !this.localMove.moveRoundPlannings?.length
				},
				{
					name: this.$t('movewizard.tab_roles'),
					icon: 'fa-user-tag',
					tag: this.localMove.moveRoles?.length,
					disabled: !this.localMove.id || !this.localMove.moveBuildings || !this.localMove.moveRoundPlannings?.length
				},
				{
					name: this.$t('movewizard.tab_questions'),
					icon: 'fa-user-tag',
					tag: this.localMove.moveQuestions.map(moveQuestionGroup => moveQuestionGroup.questions).flat().length,
					disabled: !this.localMove.id || !this.localMove.moveBuildings || !this.localMove.moveRoundPlannings?.length || !this.localMove.moveQuestionLists?.length
				},
				{
					name: this.$t('movewizard.tab_users'),
					icon: 'fa-user-tag',
					tag: this.localMove.moveUsers?.length,
					disabled: !this.localMove.id || !this.localMove.moveBuildings || !this.localMove.moveRoundPlannings?.length
				}
			];
		},
		comInternalSearch() {
			switch(this.selectedTab) {
			case 0:
				return false;
			case 1:
			case 2:
			case 3:
			case 4:
			case 5:
			case 6:
				return true;
			}
			
			return false;
		},
		comUseLayeredList() {
			switch(this.selectedTab) {
			case 0:
			case 6:
				return false;
			case 1:
			case 2:
			case 3:
			case 4:
			case 5:
				return true;
			}
			
			return false;
		},
		comUseLayeredSelectedList() {
			switch(this.selectedTab) {
			case 0:
			case 1:
			case 2:
			case 3:
			case 4:
			case 6:
				return false;
			case 5:
				return true;
			}
			
			return false;
		},
		comSubListName() {
			switch(this.selectedTab) {
			case 1:
				return 'roundPlannings';
			case 2:
				return 'fireProtections';
			case 3:
				return 'questionLists';
			case 4:
				return 'roles';
			case 5:
				return 'questions';
			case 6:
				return 'users';
			}
			
			return '';
		}
	},
	watch: {
		'getActiveCustomer.id'() {
			this.$router.push({ name: 'OngoingMovesView' });
		},
		selectedTab: {
			async handler(to, from) {
				if (!this.localMove.moveBuildings) return;
				
				await this.save(null, from);
				
				let buildingList = this.localMove.moveBuildings.map(building => building.oldBuildingId);
				let roundPlanningList = [];
				
				if (this.localMove.moveRoundPlannings?.length) {
					roundPlanningList = this.localMove.moveRoundPlannings.map(roundPlanning => roundPlanning.oldRoundPlanningId);
				}
				
				switch(to) {
				case 1:
					moveWizard.getBuildingsWithRoundPlannings(buildingList).then(async result => {
						this.roundPlannings = result;
						this.potentialProblemRoundPlannings = await this.getRoundPlanningRelatedBuildings(this.localMove.moveRoundPlannings);
					});
					
					break;
				
				case 2:
					if (this.rawFireProtections.length === 0) {
						moveWizard.getRoundPlanningsWithFireProtections(this.localMove.id, roundPlanningList).then(result => {
							this.rawFireProtections = result;
							
							if (this.localMove.moveFireProtections.length === 0) {
								this.localMove.moveFireProtections = this.getUniqueSubelements(result, 'fireProtections', 'oldFireProtectionId');
							}
						});
					}

					if (this.targetFireProtections.length === 0) {
						moveWizard.getFireProtectionsFromTargetCustomer(this.localMove.targetCustomerId).then(result => {
							this.targetFireProtections = result;
						});
					}
					
					break;
					
				case 3:
					if (this.rawQuestionLists.length === 0) {
						moveWizard.getRoundPlanningsWithQuestionLists(this.localMove.id, roundPlanningList).then(result => {
							this.rawQuestionLists = result;
							
							if (this.localMove.moveQuestionLists.length === 0)
								this.localMove.moveQuestionLists = this.getUniqueSubelements(result, 'questionLists', 'oldQuestionListId');
						});
					}

					if (this.targetQuestionLists.length === 0) {
						moveWizard.getQuestionListsFromTargetCustomer(this.localMove.targetCustomerId).then(result => {
							this.targetQuestionLists = result;
						});
					}
					
					break;
					
						
				case 4:
					moveWizard.getRoundPlanningsWithRoles(this.localMove.id, roundPlanningList).then(result => {
						this.rawRoles = result;
						this.roles = this.getUniqueElements(result, 'oldRoundPlanningId');
					});
					break;
						
				case 5:
					moveWizard.getRoundPlanningsWithQuestions(this.localMove.id, roundPlanningList).then(result => {
						this.rawQuestions = result;
						this.questions = this.formatQuestionsIntoGroups(result);
					});
					break;
							
				case 6:
					this.getUsersOnBuildings(this.localMove.moveBuildings).then(result => {
						result.forEach(user => {
							user.name = `${user.firstName} ${user.lastName}`;
						});
						this.rawUsers = result;
						this.users = result;
					});
					break;
				}
			}
		}
	},
	methods: {
		...mapActions('customerStore', ['getCustomer', 'getCustomersByCustomParams', 'setCustomers']),
		searchList(list, searchValue, searchName, searchSubElement) {
			if (searchValue) {
				list = structuredClone(list); // Make a deep copy of the list to not change original data.
				
				if (searchSubElement) {
					list.forEach(element => {
						if (element[searchSubElement].length) {
							// eslint-disable-next-line no-unused-vars
							element[searchSubElement] = element[searchSubElement].filter(element => element[searchName]?.toLowerCase().includes(searchValue));
						}
					});
					list = list.filter(element => element[searchSubElement]?.length > 0);
				} else {
					list = list.filter(element => element[searchName]?.toLowerCase().includes(searchValue));
				}
			}
			
			return list;
		},
		async getRoundPlanningRelatedBuildings(roundPlanningList) {
			let roundPlannings = roundPlanningList.map(roundPlanning => {
				return { 
					roundPlanningId: roundPlanning.oldRoundPlanningId,
					roundPlanningName: roundPlanning.roundPlanningName
				};
			});
			roundPlannings = this.getUniqueElements(roundPlannings, 'roundPlanningId');
			
			let buildingList = [];
			
			for (const roundPlanning of roundPlannings) {
				let params = {
					pageSize: 100,
					roundPlanningId: roundPlanning.roundPlanningId
				};
				await floorService.getFloors(params).then(result => {
					result.forEach(dataPoint => {
						buildingList.push({
							roundPlanningId: roundPlanning.roundPlanningId,
							roundPlanningName: roundPlanning.roundPlanningName,
							buildingName: dataPoint.buildingName,
							buildingId: dataPoint.buildingId
						});
					});
				});
			}
			
			buildingList = this.getUniqueElements(buildingList, 'buildingId');
			
			return buildingList;
			
		},
		formatQuestionsIntoGroups(questionList) {
			let uniqueQuestions = this.getUniqueSubelements(questionList, 'questions', 'oldQuestionId');
			let questionGroups = [];

			uniqueQuestions.forEach(question => {
				let foundGroup = questionGroups.find(group => group.oldQuestionGroupId == question.oldQuestionGroupId);
				
				if (!foundGroup) {
					questionGroups.push({
						moveType: question.moveType,
						oldQuestionGroupId: question.oldQuestionGroupId,
						oldQuestionGroupName: question.oldQuestionGroupName,
						questions: [question]
					});
				} else {
					foundGroup.questions.push(question);
				}
			});
			
			return questionGroups;
		},
		async getUsersOnBuildings(buildings) {
			let userList = [];
			
			for (const building of buildings) {
				await moveWizard.getUsers(building.oldBuildingId).then((result) => {
					result = result.flat();
					result.forEach(user => {
						user.oldBuildingId = building.oldBuildingId;
						user.name = `${user.firstName} ${user.lastName}`;
						user.oldId = user.id;
						user.id = null;
					});
					userList.push(result);
				});
			}

			let map = new Map(userList.flat().map(pos => [pos.oldId, pos]));
			let uniqueElements = [...map.values()];
			
			uniqueElements.sort((a, b) => {
				let nameA;
				let nameB;

				nameA = a.firstName.toLowerCase();
				nameB = b.firstName.toLowerCase();
				

				if (nameA < nameB) {
					return -1;
				}

				if (nameA > nameB) {
					return 1;
				}

				return 0;
			});
			
			return uniqueElements;
			
		},
		openCustomerSelect(isFromCustomer) {
			if (isFromCustomer) {
				this.customerSelectionTitle = this.$t('movewizard.move_from_customer_title');
				this.selectingFromCustomer = true;
				this.disabledCustomerId = this.selectedToCustomer?.id;
			} else {
				this.customerSelectionTitle = this.$t('movewizard.move_to_customer_title');
				this.selectingFromCustomer = false;
				this.disabledCustomerId = this.selectedFromCustomer?.id;
			}
			
			this.showCustomerSelection = true;
		},
		closeCustomerSelect() {
			this.showCustomerSelection = false;
		},
		getUniqueSubelements(baseList, sublistName, idName) {
			let flattenedSublist = baseList.map(roundPlanning => {
				return roundPlanning[sublistName];
			}).flat(1);
			let map = new Map(flattenedSublist.map(pos => [pos[idName], pos]));
			let uniqueElements = [...map.values()];
			
			return uniqueElements;
		},
		filterLists(baseList, filterList, idName, innerListName, innerListForBoth, parentListIdName) {
			if (filterList?.length) {
				let filteredElements = baseList.filter(this.comparer(filterList, idName));
				
				if (baseList.length && baseList[0][innerListName]?.length) {
					filteredElements = [];
					let copyList = structuredClone(baseList);
					let localFilterList = structuredClone(filterList);
					copyList.forEach(section => {
						if (innerListForBoth) {
							let foundIndex = localFilterList.findIndex(filterItem => filterItem[parentListIdName] === section[parentListIdName]);

							if (foundIndex < 0) {
								filteredElements.push(section);
							} else {
								section[innerListName] = section[innerListName].filter(this.comparer(localFilterList[foundIndex][innerListName], idName));
								filteredElements.push(section);
							}
						} else {
							section[innerListName] = section[innerListName].filter(this.comparer(localFilterList, idName));
							filteredElements.push(section);
						}
					});
				}

				return filteredElements;
			}

			return baseList;
		},
		comparer(otherArray, idName) {
			let idNameToUse = idName ?? 'id';
			
			return function(current) {
				return (
					otherArray.filter(function(other) {
						return other[idNameToUse] === current[idNameToUse];
					}).length === 0
				);
			};
		},
		async retreiveBuildings(name) {
			let searchParams = {
				name: name,
				customerId: this.selectedFromCustomer.id ?? this.getActiveCustomer.id,
				orderBy: 'Name',
				currentPage: 1,
				pageSize: 100
			};
			await this.$services.building.getBuildings(searchParams).then(result => {
				result.forEach(building => building.oldBuildingId = building.id);
				this.buildings = result;
			});
		},
		cancel() {
			this.$router.push(`/${this.$i18n.locale}/OngoingMoves`);

		},
		async save(event, tabToSave) {
			if (this.disableSave) return;
			
			switch (tabToSave ?? this.selectedTab) {
			case 0:
				await this.createNewMove();
				break;
			case 1:
				await this.addRoundPlanningsToMove();
				break;
			case 2:
				await this.addFireProtectionsToMove();
				break;
			case 3:
				await this.addQuestionListsToMove();
				break;
			case 4:
				await this.addRolesToMove();
				break;
			case 5:
				await this.addQuestionsToMove();
				break;
			case 6:
				await this.addUsersToMove();
				break;
			}
		},
		async createNewMove() {
			let buildingsToCreate = this.localMove.moveBuildings.map(building => {
				return { buildingId: building.oldBuildingId, moveType: building.moveType };
			});
			
			let createMoveObject = {
				targetCustomerId: this.selectedToCustomer.id,
				moveBuildingRequests: buildingsToCreate
			};
			
			if (this.localMove.id) {
				createMoveObject.moveId = this.localMove.id;
			}
			
			await moveWizard.createMove(createMoveObject).then(result => {
				this.setLocalMove(result);
			});
		},
		async addRoundPlanningsToMove() {
			let roundPlanningList = [];
			
			this.roundPlannings.forEach(buildingRoundPlanning => {
				let buildingRoundPlannings = buildingRoundPlanning.roundPlannings.map(roundPlanning => {
					let planning = this.localMove.moveRoundPlannings.find(moveRoundPlanning => moveRoundPlanning.oldRoundPlanningId === roundPlanning.oldRoundPlanningId);
					
					if (planning) {
						let foundBuilding = this.localMove.moveBuildings.find(building => building.oldBuildingId === buildingRoundPlanning.oldBuildingId);
						let newRoundPlanning = { roundPlanningId: planning.oldRoundPlanningId, moveType: planning.moveType, moveBuildingId: foundBuilding.id };
						
						return newRoundPlanning;
					}
				});
				
				buildingRoundPlannings = buildingRoundPlannings.flat().filter((element) => {
					return element !== undefined;
				});
				
				if (buildingRoundPlannings && buildingRoundPlannings[0]) {
					roundPlanningList.push(buildingRoundPlannings);	
				}
				
			});
			
			roundPlanningList = roundPlanningList.flat(1).filter((element) => {
				return element !== undefined;
			});
			
			await moveWizard.addRoundPlanningsToMove(roundPlanningList.flat(1), this.localMove.id).then(result => {
				this.setLocalMove(result);
			});
			
			let roundPlanningHistories = [];
			for (const roundPlanning of this.localMove.moveRoundPlannings) {
				let roundPlanningModel = {
					moveRoundPlanningId: roundPlanning.oldRoundPlanningId,
					keepHistory: true
				};
				roundPlanningHistories.push(roundPlanningModel);
			}
			
			await moveWizard.setKeepOnRoundPlannings(roundPlanningHistories);
			this.potentialProblemRoundPlannings = await this.getRoundPlanningRelatedBuildings(this.localMove.moveRoundPlannings);
		},
		async addFireProtectionsToMove() {
			let list = this.setupListForSave(this.rawFireProtections, this.localMove.moveFireProtections, 'fireProtections', 'oldFireProtectionId', 'fireProtectionId');
			
			await moveWizard.addFireProtectionsToMove(list, this.localMove.id).then(result => {
				this.setLocalMove(result);
			});
		},
		async addQuestionListsToMove() {
			let list = this.setupListForSave(this.rawQuestionLists, this.localMove.moveQuestionLists, 'questionLists', 'oldQuestionListId', 'questionListId');
			
			await moveWizard.addQuestionListsToMove(list, this.localMove.id).then(result => {
				this.setLocalMove(result);
			});
		},
		async addRolesToMove() {
			let list = this.setupListForSave(this.rawRoles, this.localMove.moveRoles, 'roles', 'oldRoleId', 'roleId');
			
			await moveWizard.addRolesToMove(list, this.localMove.id).then(result => {
				this.setLocalMove(result);
			});
		},
		async addQuestionsToMove() {
			let list = [];
			this.rawQuestions.forEach(rawRoundPlanningQuestions => {
				let elements = rawRoundPlanningQuestions.questions.map(rawQuestion => {
					let questionGroupIdIndex = this.localMove.moveQuestions.findIndex(moveQuestion => moveQuestion.oldQuestionGroupId === rawQuestion.oldQuestionGroupId);

					if (questionGroupIdIndex < 0) return;

					let elementMatch = this.localMove.moveQuestions[questionGroupIdIndex].questions.find(question => question.oldQuestionId == rawQuestion.oldQuestionId);
					
					if (!elementMatch) return;
					
					let foundRoundPlanning = this.localMove.moveRoundPlannings.find(roundPlanning => {
						return roundPlanning.id === rawRoundPlanningQuestions.id;
					});
					
					if (!foundRoundPlanning) return;
					
					let newElement = { moveRoundPlanningId: foundRoundPlanning.id, questionId: elementMatch.oldQuestionId, moveType: this.localMove.moveQuestions[questionGroupIdIndex].moveType, idToReplace: elementMatch.idToReplace };
					
					return newElement;
				});
				
				list.push(elements);
			});
			
			list = list.flat(1).filter((element) => {
				return element !== undefined;
			});

			await moveWizard.addQuestionsToMove(list, this.localMove.id).then(result => {
				this.setLocalMove(result);
			});
		},
		async addUsersToMove() {
			let userList = [];
			
			this.localMove.moveUsers.forEach(moveUser => {
				let foundBuilding = this.localMove.moveBuildings.find(building => building.oldBuildingId === moveUser.oldBuildingId || building.id === moveUser.moveBuildingId);
				let newUser = { userId: moveUser.oldId, moveType: moveUser.moveType, moveBuildingId: foundBuilding.id };
				
				userList.push(newUser);
			});
			
			await moveWizard.addUsersToMove(userList, this.localMove.id).then(result => {
				this.setLocalMove(result);
			});
		},
		setupListForSave(comparisonList, moveList, sublistName, idName, idParameterName) {
			let list = [];
			comparisonList.forEach(comparisonElement => {
				let elements = comparisonElement[sublistName].map(sublistElement => {
					let elementMatch = moveList.find(moveElement => moveElement[idName] == sublistElement[idName]);
					
					if (!elementMatch) return;
					
					let foundRoundPlanning = this.localMove.moveRoundPlannings.find(roundPlanning => {
						return roundPlanning.id === comparisonElement.id;
					});
					
					if (!foundRoundPlanning) return;
					
					let newElement = { moveRoundPlanningId: foundRoundPlanning.id, [idParameterName]: elementMatch[idName], moveType: elementMatch.moveType, idToReplace: elementMatch.idToReplace };
					
					return newElement;
				});
				
				list.push(elements);
			});
			
			list = list.flat(1).filter((element) => {
				return element !== undefined;
			});
			
			return list;
		},
		setLocalMove(move) {
			this.localMove = move;
			
			this.localMove.moveRoundPlannings = this.extractListFromParentObject(this.localMove.moveBuildings, 'roundPlannings');
			
			this.localMove.moveFireProtections = this.getUniqueElements(this.extractListFromParentObject(this.localMove.moveRoundPlannings, 'fireProtections'), 'oldFireProtectionId');

			this.localMove.moveQuestionLists = this.getUniqueElements(this.extractListFromParentObject(this.localMove.moveRoundPlannings, 'questionLists'), 'oldQuestionListId');

			this.localMove.moveRoles = this.getUniqueElements(this.extractListFromParentObject(this.localMove.moveRoundPlannings, 'roles'), 'oldRoleId');
			
			this.localMove.moveQuestions = this.formatQuestionsIntoGroups(this.localMove.moveRoundPlannings);
			
			this.localMove.moveUsers = this.extractListFromParentObject(this.localMove.moveBuildings, 'users');
			this.localMove.moveUsers.forEach(user => {
				user.name = `${user.firstName} ${user.lastName}`;
				
				if (!user.oldId) {
					user.oldId = user.id;
					user.id = null;
				}
			});
			
			this.localMove = Object.assign({}, this.localMove);
		},
		getUniqueElements(baseList, property) {
			let map = new Map(baseList.map(pos => [pos[property], pos]));
			let uniqueElements = [...map.values()];
			
			return uniqueElements;
		},
		extractListFromParentObject(buildingList, listName) {			
			if (!buildingList?.length || !buildingList[0][listName]) return [];
			
			let newList = buildingList.map(building => building[listName])?.flat(1);

			return newList;
		},
		addItem(item) {
			let itemIndex = -1;
			
			switch (this.selectedTab) {
			case 0:
				item.buildingName = item.name;
				item.moveType = 1;
				this.localMove.moveBuildings.push(item);
				break;
			case 1:
				this.localMove.moveRoundPlannings.push(item);
				break;
			case 2:
				this.localMove.moveFireProtections.push(item);
				break;
			case 3:
				this.localMove.moveQuestionLists.push(item);
				break;
			case 4:
				this.localMove.moveRoles.push(item);
				break;
			case 5:
				this.localMove.moveQuestions.push(item);
				break;
			case 6:
				itemIndex = this.localMove.moveUsers.findIndex(listItem => listItem.oldId == item.oldId);
				
				if (itemIndex < 0) {
					item.moveType = 1;
					this.localMove.moveUsers.push(item);
				}
				
				break;
			}
		},
		addSubItem(item, subitem) {
			let itemIndex = -1;
			let groupIndex = -1;
			
			switch (this.selectedTab) {
			case 1:
				itemIndex = this.localMove.moveRoundPlannings.findIndex(moveItem => moveItem.oldRoundPlanningId == subitem.oldRoundPlanningId);
				
				if (itemIndex < 0) {
					this.localMove.moveRoundPlannings.push(subitem);
				}
				
				break;
			case 2:
				itemIndex = this.localMove.moveFireProtections.findIndex(moveItem => moveItem.oldFireProtectionId == subitem.oldFireProtectionId);
				
				if (itemIndex < 0) {
					this.localMove.moveFireProtections.push(subitem);
				}
				
				break;
			case 3:
				itemIndex = this.localMove.moveQuestionLists.findIndex(moveItem => moveItem.oldQuestionListId == subitem.oldQuestionListId);
				
				if (itemIndex < 0) {
					this.localMove.moveQuestionLists.push(subitem);
				}
				
				break;
			case 4:
				itemIndex = this.localMove.moveRoles.findIndex(moveItem => moveItem.oldRoleId == subitem.oldRoleId);
				
				if (itemIndex < 0) {
					this.localMove.moveRoles.push(subitem);
				}
				
				break;
			case 5:
				groupIndex = this.localMove.moveQuestions.findIndex(moveItem => moveItem.oldQuestionGroupId == item.oldQuestionGroupId);
				
				if (groupIndex < 0) {
					this.localMove.moveQuestions.push({
						moveType: 0,
						oldQuestionGroupId: subitem.oldQuestionGroupId,
						oldQuestionGroupName: subitem.oldQuestionGroupName,
						questions: [subitem]
					});
				} else {
					itemIndex = this.localMove.moveQuestions[groupIndex].questions.findIndex(moveItem => moveItem.oldQuestionId === subitem.oldQuestionId);

					if (itemIndex < 0) {
						this.localMove.moveQuestions[groupIndex].questions.push(subitem);
					}
				}
				
				break;
			}
		},
		addAllSubItems(item) {
			let itemIndex = -1;
			let foundGroup = [];

			switch(this.selectedTab) {
			case 5:
				foundGroup = this.localMove.moveQuestions.find(moveQuestionGroup => moveQuestionGroup.oldQuestionGroupId === item.oldQuestionGroupId);

				if (!foundGroup) {
					this.localMove.moveQuestions.push(item);
					foundGroup = this.localMove.moveQuestions[this.localMove.moveQuestions.length - 1];
				}

				item.questions.forEach(question => {
					itemIndex = foundGroup.questions.findIndex(moveQuestion => moveQuestion.oldQuestionId == question.oldQuestionId);
				
					if (itemIndex < 0) {
						foundGroup.questions.push(question);
					}		
				});
				break;
			}
		},
		removeItem(item) {
			switch (this.selectedTab) {
			case 0:
				this.removeItemFromList(this.localMove.moveBuildings, item);
				break;
			case 1:
				this.removeItemFromList(this.localMove.moveRoundPlannings, item);
				break;
			case 2:
				this.removeItemFromList(this.localMove.moveFireProtections, item);
				break;
			case 3:
				this.removeItemFromList(this.localMove.moveQuestionLists, item);
				break;
			case 4:
				this.removeItemFromList(this.localMove.moveRoles, item);
				break;
			case 5:
				this.removeItemFromList(this.localMove.moveQuestions, item);
				break;
			case 6:
				this.removeItemFromList(this.localMove.moveUsers, item);
				break;
			}
		},
		removeItemFromList(list, itemToRemove, propertyToUse = 'id') {
			var indexToRemove = list.findIndex(listItem => listItem[propertyToUse] == itemToRemove[propertyToUse]);
			
			if (indexToRemove !== -1)
				list.splice(indexToRemove, 1);
		},
		removeSubItem(item, subItem) {
			switch(this.selectedTab) {
			case 5:
				var parentItemIndex = this.localMove.moveQuestions.findIndex(listItem => listItem.oldQuestionGroupId == item.oldQuestionGroupId);
				
				if (parentItemIndex !== -1 && this.localMove.moveQuestions[parentItemIndex])
					this.removeItemFromList(this.localMove.moveQuestions[parentItemIndex].questions, subItem);
					
				break;
			}
		},
		removeAllSubItems(item) {
			switch(this.selectedTab) {
			case 5:
				this.removeItemFromList(this.localMove.moveQuestions, item, 'oldQuestionGroupId');
				break;
			}
		},
		listItemOptionSelect(item, value) {
			let foundItem;
			
			switch (this.selectedTab) {
			case 0:
				foundItem = this.localMove.moveBuildings.find(searchItem => searchItem.oldBuildingId == item.oldBuildingId);
				foundItem.moveType = value;
				this.localMove.moveBuildings = Object.assign([], this.localMove.moveBuildings);
				break;
			case 1:
				foundItem = this.localMove.moveRoundPlannings.find(searchItem => searchItem.oldRoundPlanningId == item.oldRoundPlanningId);
				foundItem.moveType = value;
				this.localMove.moveRoundPlannings = Object.assign([], this.localMove.moveRoundPlannings);
				break;
			case 2:
				foundItem = this.localMove.moveFireProtections.find(searchItem => searchItem.oldFireProtectionId == item.oldFireProtectionId);
				
				
				if (foundItem.moveType === 2 && value !== 2) {
					foundItem.idToReplace = null;
				}
				
				foundItem.moveType = value;
				this.localMove.moveFireProtections = Object.assign([], this.localMove.moveFireProtections);
				break;
			case 3:
				foundItem = this.localMove.moveQuestionLists.find(searchItem => searchItem.oldQuestionListId == item.oldQuestionListId);
				foundItem.moveType = value;
				this.localMove.moveQuestionLists = Object.assign([], this.localMove.moveQuestionLists);
				break;
			case 4:
				foundItem = this.localMove.moveRoles.find(searchItem => searchItem.oldRoleId == item.oldRoleId);
				foundItem.moveType = value;
				this.localMove.moveRoles = Object.assign([], this.localMove.moveRoles);
				break;
			case 5:
				foundItem = this.localMove.moveQuestions.find(searchItem => searchItem.oldQuestionId == item.oldQuestionId);
				foundItem.moveType = value;
				this.localMove.moveQuestions = Object.assign([], this.localMove.moveQuestions);
				break;
			case 6:
				foundItem = this.localMove.moveUsers.find(searchItem => searchItem.oldId == item.oldId);
				foundItem.moveType = value;
				this.localMove.moveUsers = Object.assign([], this.localMove.moveUsers);
				break;
			}
		},
		listGroupItemOptionSelect(item, value) {
			let foundItem;
			
			switch (this.selectedTab) {
			case 5:
				foundItem = this.localMove.moveQuestions.find(searchItem => searchItem.oldQuestionGroupId == item.oldQuestionGroupId);
				foundItem.moveType = value;
				break;
			}
		},
		listItemReplacementSelect(item, value) {
			let foundItemIndex;

			switch (this.selectedTab) {
			case 2:
				foundItemIndex = this.localMove.moveFireProtections.findIndex(searchItem => searchItem.id == item.id);
				this.localMove.moveFireProtections[foundItemIndex].idToReplace = value;
				break;
			case 3:
				foundItemIndex = this.localMove.moveQuestionLists.findIndex(searchItem => searchItem.id == item.id);
				this.localMove.moveQuestionLists[foundItemIndex].idToReplace = value;
				break;
			}
		},
		searchAdd(searchValue) {
			if (this.comInternalSearch) {
				this.addSearchValue = searchValue.toLowerCase();
			}
			
			switch (this.selectedTab) {
			case 0:
				this.retreiveBuildings(searchValue);
				break;
			case 1:
			case 2:
			case 3:
			case 4:
				break;
			}
		},
		searchAdded(value) {
			this.addedSearchValue = value.toLowerCase();
		},
		selectCustomer(customer) {
			if (this.selectingFromCustomer) {
				this.selectFromCustomer(customer);
			} else {
				this.selectToCustomer(customer);
			}
			
			this.showCustomerSelection = false;
		},
		selectFromCustomer(customer) {
			this.selectedFromCustomer = customer;
			this.localMove.fromCustomerName = customer.name;
			this.localMove.fromCustomerId = customer.id;
			
			if (!this.localMove.id) {
				this.localMove.moveBuildings = [];
			}
			
			this.retreiveBuildings();
		},
		selectToCustomer(customer) {
			this.selectedToCustomer = customer;
			this.localMove.targetCustomerName = customer.name;
			this.localMove.targetCustomerId = customer.id;
		},
		searchCustomer(customerName) {
			let searchParams = {
				name: customerName,
				orderBy: 'Name',
				pageSize: 10,
				currentPage: 1,
				companyId: this.getActiveCompany.id
			};
			this.getCustomersByCustomParams(searchParams).then((data) => {
				this.setCustomers(data);
			});
		},
		navigateToSummary() {
			if (this.localMove.id) {
				this.$router.push(`/${this.$i18n.locale}/MoveSummary/${this.localMove.id}`);
			}
		}
	},
	created() {
		let moveId = this.$route.params.moveId;
		
		if (!this.getActiveCustomer?.id && moveId == 0) {
			this.$router.push(`/${this.$i18n.locale}/OngoingMoves`);
		}
		
		if (moveId != 0) {
			moveWizard.getMoveSummary(moveId).then(data => {
				this.setLocalMove(data);
				this.$services.customer.getCustomer(data.fromCustomerId).then(customer => {
					this.selectFromCustomer(customer);
				});
				this.$services.customer.getCustomer(data.targetCustomerId).then(customer => {
					this.selectToCustomer(customer);
				});
				
				this.showLists = true;
			});
		} else {
			let searchParams = {
				orderBy: 'Name',
				pageSize: 0,
				currentPage: 1,
				companyId: this.getActiveCompany.id
			};
			this.getCustomersByCustomParams(searchParams).then((data) => {
				this.setCustomers(data);
				this.selectFromCustomer(this.getActiveCustomer);
				this.showLists = true;
			});
		}
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/colors.scss";

.customer-select-button {
	background: white;
	border: 1px solid $multiselect-border-color;
	border-radius: 1px;
	box-shadow: 0 0.0625em 0.25em #0a0a0a0d inset;
	font-size: 16px;
	width: 100%;
	padding: 5px;
	min-height: 40px;
	min-width: 300px;
	font-family: inherit;
	text-align: left;
	cursor: pointer;
	&:disabled {
		color: #23282d;
		cursor: default;
	}
}

.hide-outline:not(.is-mobile) {
	height: 100%;
	.main-view {
		display: flex;
		flex-direction: column;
	}
	
	.lists.columns {
		overflow: hidden;
		height: 100%;
	}
}

.top-box {
  background: $lightest-grey;
  padding: 10px 5px 10px 5px;
  display: block;
  border-radius: 2px;
  margin-bottom: 10px;
  .row {
    display: flex;
		flex-wrap: wrap;
    position: relative;
  }
	
	.fields {
		display: flex;
	}
	
  .field {
    flex: 1;
    margin-left: 10px;
    margin-right: 10px;
    .label {
      font-size: 12px;
    }
  }
  .buttons {
    margin: 0;
    margin-top: 10px;
    justify-content: flex-end;
    &.is-mobile {
      margin-top: 1.2rem;
      margin-right: 0.7rem;
    }
    .button {
      border-radius: 2px;
      min-width: 110px;
    }
  }
}

.lists.columns {
  margin-top: 10px;
	min-height: 300px;
}

.warnings {
	height: 30%;
	max-height: 100px;
	overflow-y: scroll;
	.warning {
		color: $danger;
		font-weight: 600;
		font-size: 14px;
	}
}

</style>
